import departmentReducer from '@/features/departments/stores/department.slice'
import appGlobalReducer from '../slices/appGlobal.slice'
const rootReducer = {
  appGlobal: appGlobalReducer,
  department: departmentReducer,
}

export default rootReducer
